import { Typography, Grid2, Button, Stack } from "@mui/material";
import { LandingPageSection } from "../static-page-components/landing-page-section";
import FindingYourPerfectMatch from "../../assets/home-owner/images/Finding Your Perfect Match.jpg";
import HowDesignersCharge from "../../assets/home-owner/images/How Designers Charge.jpg";
import WhyHireADesignerProfessional from "../../assets/home-owner/images/Why Hire a Designer Professional.jpg";
import { BlogCard } from "./blog-card";
import { Pages } from "../../utils";
import { Link } from "react-router";

const paidGuildGuidesIframePath = `${Pages.HOMEOWNER_GUILD_GUIDES}`;

const blogCards = [
    {
        image: WhyHireADesignerProfessional,
        title: "Why Hire a Designer Professional",
        description:
            'Discover Guild Guides by Home Design Guild - a trusted resource to navigate your interior designer search. From "Working with a Designer 101" to "How Designers Charge," get expert insights, unlock inspiration, and find your perfect design match through our vetted community and innovative matchmaking approach.',
        to: Pages.HOMEOWNER_GUILD_GUIDE_POST.replace(
          ":slug",
          "why-hire-an-interior-design-professional"
        ),
    },
    {
        image: FindingYourPerfectMatch,
        title: "Finding Your Perfect Match",
        description:
            "At Home Design Guild, we believe great design starts with genuine connection. Finding a designer who aligns not just with your style, but with you, can transform the experience from transactional to truly personal.",
        to: Pages.HOMEOWNER_GUILD_GUIDE_POST.replace(
          ":slug",
          "finding-your-perfect-interior-designer"
        ),
    },
    {
        image: HowDesignersCharge,
        title: "How Designers Charge",
        description:
            'When embarking on an interior design project, one of the first questions homeowners ask is, "How much will it cost?" Understanding how interior designers and decorators charge for their services is crucial for budgeting and setting clear expectations. Designers can offer a range of pricing structures, tailored to the scope of work, expertise, and project needs. Below, we\'ll explore the most common pricing models used by interior designers and decorators to help you make an informed decision.',
        to: Pages.HOMEOWNER_GUILD_GUIDE_POST.replace(
          ":slug",
          "how-interior-designers-charge"
        ),
    },
];

export const BlogModuleSection = () => (
    <LandingPageSection sx={{ pb: 8, pl: { xs: 4, md: 0 }, pr: { xs: 4, md: 0 } ,pt:{md:8},mt:{md:13.5}}}>
        <Grid2 container columns={12} >
            <Grid2 size={{ xs: 12, md: 12 }} sx={{ textAlign: { xs: "justify", md: "center" } }}>
                <Stack
                    direction="row"
                    alignItems="center"
                    justifyContent={{ xs: "flex-start", md: "center" }}
                    spacing={1.5}
                    sx={{ mb: 1 }}
                >
                    <Typography
                        component={Link}
                        to={paidGuildGuidesIframePath}
                        variant="overline"
                        className="text-purple"
                        sx={{
                            textAlign: { xs: "left", md: "center" },
                            textDecoration: "none",
                            "&:hover": { textDecoration: "underline" },
                        }}
                    >
                        GUILD GUIDES
                    </Typography>
                    <Button
                        component={Link}
                        to={paidGuildGuidesIframePath}
                        size="small"
                        variant="text"
                        color={"purple" as any}
                        sx={{ textTransform: "none", minWidth: "auto", px: 1 }}
                    >
                        View All
                    </Button>
                </Stack>
                <Typography variant={"display2" as any}
                    component="h2"
                    className="text-center text-pink" sx={{ mb: 3, textAlign: { xs: "left", md: "center" } }}>
                    NOT ALL BEAUTY, BRAINS TOO
                </Typography>
                <Typography variant="body1" className="contain-text-large text-center" sx={{ mb: 5, fontSize: "20px", lineHeight: "32px", textAlign: { xs: "left", md: "center" } }}>
                    We're also here to help you feel empowered as you embark on your home design journey. With Guild Guides understand what real design projects look like, what they cost, and how to expertly navigate matching with your design professional.
                </Typography>
            </Grid2>
        </Grid2>
        <Grid2 container spacing={{ xs: 5, md: 4 }} sx={{ mb: { xs: 0, md: 8 } }}>
            {blogCards.map((card, idx) => (
                <Grid2 size={{ xs: 12, md: 4 }} key={card.title + idx}>
                    <BlogCard
                        image={card.image}
                        title={card.title}
                        description={card.description}
                        to={card.to}
                    />
                </Grid2>
            ))}
        </Grid2>
    </LandingPageSection>
); 
